import { Box, Chip, Grid, Stack, Tooltip, Typography } from '@mui/material';
import MUIDataTable from 'mui-datatables';
import * as React from 'react';
import * as Redux from 'react-redux';
import styled from 'styled-components';
import * as CONST from '../../../../constants/FieldsConst';
import { textLabels } from '../../../../helpers';
import { useNotification } from '../../../../helpers/Notification';
import { LoadingWidget } from '../../../../widgets';
import ActionsListWidget from '../../../../widgets/ActionsList';
import DeleteModalComponent from '../../../../widgets/modals/DeleteModal';
import { allEntCarrerasAction } from '../../../entidad/ent_carreras/EntCarrerasAction';
import { NameComponent } from '../../../usuario/usuarios/components/ListadoUsuarios';
import {
  allMateriasAction,
  deleteMateriasAction,
  setActivoMateriasAction,
} from '../MateriasAction';
import { PARAMS_MATERIAS } from '../MateriasReducer';

export const Links = styled.a`
  cursor: pointer;
  color: black;
  margin: 0px 0px;
  text-decoration: none;

  &:hover {
    color: blue;
  }
`;

const ListadoMaterias = ({ setOpenModalForm }) => {
  const dispatch = Redux.useDispatch();
  const { notify } = useNotification();

  const loginStore = Redux.useSelector((state) => state.login);
  const entCarrerasStore = Redux.useSelector((state) => state.entCarreras);
  const entidadesStore = Redux.useSelector((state) => state.entidades);
  const materiasStore = Redux.useSelector((state) => state.materias);

  const [loadingDelete, setLoadingDelete] = React.useState(false);
  const [openModalDelete, setOpenModalDelete] = React.useState(false);

  React.useEffect(() => {
    async function fetchData() {
      if (entCarrerasStore.all && entCarrerasStore.all.length === 0) {
        await allEntCarrerasAction(dispatch, {
          idEntidad: entidadesStore.activo.id,
        });
      }

      const payload = {
        idEntidad: entidadesStore.activo.id,
        ...materiasStore.params,
      };
      dispatch({ type: PARAMS_MATERIAS, payload });
      if (materiasStore.all && materiasStore.all.length === 0) {
        await allMateriasAction(dispatch, payload);
      }
    }
    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const _handleEditClick = async (id) => {
    const data = materiasStore.all.find((el) => el.id === id);
    await setActivoMateriasAction(dispatch, data);
    setOpenModalForm(true);
  };

  const _onDeleteHandler = async () => {
    setLoadingDelete(true);
    await deleteMateriasAction(
      { dispatch, notify },
      materiasStore.activo.id,
      materiasStore.params,
    );
    setLoadingDelete(false);
    setOpenModalDelete(false);
  };

  const columns = [
    {
      name: CONST.ID,
      options: {
        display: loginStore.isRoot ? false : 'excluded',
        filter: false,
      },
    },
    {
      name: CONST.nombre.name,
      label: CONST.nombre.label,
      options: {
        filter: true,
        sort: true,
        customBodyRender: (value, tableMeta, updateValue) => {
          return (
            <NameComponent
              onClick={() => _handleEditClick(tableMeta.rowData[0])}
            >
              {value}
            </NameComponent>
          );
        },
      },
    },
    {
      name: CONST.color.name,
      label: CONST.color.label,
      options: {
        filter: true,
        sort: true,
        customBodyRender: (value, tableMeta, updateValue) => {
          return (
            <Box
              sx={{
                width: '30px',
                height: '30px',
                backgroundColor: value ?? '#454545',
              }}
            ></Box>
          );
        },
      },
    },
    {
      name: CONST.link.name,
      label: CONST.link.label,
      options: {
        filter: true,
        sort: true,
        customBodyRender: (value, tableMeta, updateValue) => {
          return (
            <Box
              sx={{
                width: value.length > 100 ? '15vw' : '10vw',
                overflow: 'hidden',
                mr: 1,
              }}
            >
              <Links target="_blank" href={value}>
                {value}
              </Links>
            </Box>
          );
        },
      },
    },
    {
      name: CONST.referencia.name,
      label: CONST.referencia.label,
      options: {
        filter: true,
        sort: true,
        customBodyRender: (value, tableMeta, updateValue) => {
          return (
            <Box
              sx={{
                width: value.length > 100 ? '15vw' : '10vw',
                overflow: 'hidden',
                mr: 1,
              }}
            >
              <Links target="_blank" href={value}>
                {value}
              </Links>
            </Box>
          );
        },
      },
    },
    {
      name: CONST.carreras.name,
      label: CONST.carreras.label,
      options: {
        filter: false,
        sort: false,
        customBodyRender: (value, tableMeta, updateValue) => {
          if (value && value.length > 2) {
            return (
              <Box
                sx={{ display: 'flex', flexDirection: 'row', width: '10vw' }}
              >
                <Chip
                  size="small"
                  color="primary"
                  variant="outlined"
                  label={`${value[0].carrera.carrera.nombre} | ${value[0].carrera.modalidad}`}
                  sx={{ mr: 1 }}
                />
                <Chip size="small" label=" +2 " color="primary" />
              </Box>
            );
          }
          if (value && value.length >= 1) {
            return value.map((el, index) => (
              <Chip
                key={`listCar${index}`}
                size="small"
                color="primary"
                variant="outlined"
                label={`${el.carrera.carrera.nombre} | ${el.carrera.modalidad}`}
                sx={{ mr: 1, mt: 0.5 }}
              />
            ));
          }

          return <Box sx={{ width: '5vw' }}></Box>;
        },
      },
    },
    {
      name: CONST.desc.name,
      label: CONST.desc.label,
      options: {
        filter: true,
        sort: true,
      },
    },
    {
      name: CONST.estatus.name,
      label: CONST.estatus.label,
      options: {
        filter: true,
        sort: true,
        customBodyRender: (value, tableMeta, updateValue) => {
          return (
            <Box sx={{ width: '70px' }}>
              <Tooltip
                describeChild
                title="Estatus del registro"
                placement="left"
              >
                <Chip
                  label={value.nombre}
                  size="small"
                  color={value.id === 1 ? 'success' : 'error'}
                />
              </Tooltip>
            </Box>
          );
        },
      },
    },
    {
      name: CONST.actions.name,
      label: CONST.actions.label,
      options: {
        filter: false,
        sort: false,
        empty: true,
        customBodyRender: (value, tableMeta, updateValue) => {
          return (
            <Box sx={{ width: '70px' }}>
              <Stack direction="row">
                <ActionsListWidget
                  id={tableMeta.rowData[0]}
                  onEdit={() => _handleEditClick(tableMeta.rowData[0])}
                  onDelete={async () => {
                    const data = materiasStore.all.find(
                      (el) => el.id === tableMeta.rowData[0],
                    );
                    await setActivoMateriasAction(dispatch, data);
                    setOpenModalDelete(true);
                  }}
                />
              </Stack>
            </Box>
          );
        },
      },
    },
  ];

  const options = {
    filterType: 'dropdown',
    reponsive: 'scroll',
    setTableProps: () => {
      return {
        padding: 'none',
        size: 'small',
      };
    },
    rowsPerPage: 25,
    rowsPerPageOptions: [25, 50, 100],
    print: false,
    download: false,
    textLabels,
    selectableRowsHideCheckboxes: true,
    expandableRows: true,
    renderExpandableRow: (rowData, rowMeta) => {
      return <Grid container></Grid>;
    },
  };

  return (
    <Grid container>
      <Grid item md={12}>
        <LoadingWidget isLoading={materiasStore.loadingAll || loadingDelete} />
        <MUIDataTable
          title={'Listado'}
          data={materiasStore.all}
          columns={columns}
          options={options}
        />
      </Grid>
      {materiasStore.activo && (
        <DeleteModalComponent
          open={openModalDelete}
          onClose={() => setOpenModalDelete(!openModalDelete)}
          onDelete={_onDeleteHandler}
        >
          <Typography variant="h6">{materiasStore.activo.nombre}</Typography>
        </DeleteModalComponent>
      )}
    </Grid>
  );
};

export default ListadoMaterias;
